import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UserType} from '../../types/UserType';

export interface LoggedInUserState {
    requested: boolean;
    loggedIn: boolean;
    accessDenied: boolean;
    userData?: UserType;
}

const initialState: LoggedInUserState = {
    requested: false,
    loggedIn: false,
    accessDenied: false,
    userData: undefined
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        loggedIn: (state, action: PayloadAction<UserType>) => {
            state.requested = true;
            state.loggedIn = true;
            state.accessDenied = false;
            state.userData = action.payload;
        },
        loggedOut: (state) => {
            state.requested = false;
            state.loggedIn = false;
            state.accessDenied = false;
            state.userData = undefined;
        },
        accessDenied: (state) => {
            state.accessDenied = true;
        }
    }
});

export const {loggedIn, loggedOut, accessDenied} = loginSlice.actions;
export default loginSlice.reducer;
